

































import { Component, Prop } from 'vue-property-decorator';
import SaascadaVue from '@/components/Shared/SaascadaVue';
import GeneralFeeSettingsEditDialog from '@/components/Products/ProductFees/General/GeneralFeeSettingsEditDialog.vue';
import { ProductDetailsModule } from '@/store/Products/ProductDetailsModule';
import { ProductIssueDetailsModule } from '@/store/Products/ProductIssueDetailsModule';
import EntityType from '@/models/Shared/EntityType';

@Component({ name: 'GeneralFeeSettings', components: { GeneralFeeSettingsEditDialog } })
export default class extends SaascadaVue {

    EntityType = EntityType;

    @Prop({required: true})
    entityType: EntityType;

    get generalFeeSettings() {
        if (this.entityType === EntityType.Product) {
            return ProductDetailsModule.product.generalFeeSettings;
        }
        return ProductIssueDetailsModule.productIssue.generalFeeSettings;
    }

}
